module.exports = __webpack_public_path__ + "static/media/Serial Position Effect.e7efaaf9.jpg";